/**
 * JALRAKSHAK Clean Nodemailer Contact Engine
 * Submits form data directly to backend /api/contact endpoint.
 */

import { showToast } from './vcard.js';

export function initContactForm() {
  const contactForm = document.getElementById('collaborate-form');
  const submitBtn = document.getElementById('btn-submit-contact');
  const responseBox = document.getElementById('contact-response-status');

  contactForm?.addEventListener('submit', async (e) => {
    e.preventDefault();

    const name = document.getElementById('contact-name')?.value.trim();
    const email = document.getElementById('contact-email')?.value.trim();
    const phone = document.getElementById('contact-phone')?.value.trim() || '';
    const category = document.getElementById('contact-category')?.value || 'General Inquiries';
    const message = document.getElementById('contact-message')?.value.trim();

    if (!name || !email || !message) {
      showToast('Please fill out Name, Email, and Message.');
      return;
    }

    // Loading State
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.innerHTML = `
        <div style="width: 16px; height: 16px; border: 2px solid #FFFFFF; border-top-color: transparent; border-radius: 50%; animation: spin 0.6s linear infinite; display: inline-block;"></div>
        <span>SENDING MESSAGE...</span>
      `;
    }

    if (responseBox) {
      responseBox.style.display = 'none';
      responseBox.innerHTML = '';
    }

    try {
      const response = await fetch('/api/contact', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          name,
          email,
          phone,
          category,
          message
        })
      });

      const result = await response.json();

      if (response.ok && result.success) {
        // Success feedback
        if (responseBox) {
          responseBox.style.display = 'block';
          responseBox.innerHTML = `
            <div style="background: rgba(16, 185, 129, 0.15); border: 1px solid rgba(16, 185, 129, 0.4); border-radius: var(--radius-md); padding: 1.2rem 1.5rem; color: #FFFFFF; display: flex; align-items: center; gap: 0.8rem;">
              <span style="font-size: 1.4rem; color: #34D399;">✓</span>
              <div>
                <strong style="color: #34D399; font-size: 1rem;">Message Sent Successfully!</strong>
                <div style="font-size: 0.88rem; color: var(--text-secondary); margin-top: 0.2rem;">
                  Thank you <strong>${escapeHtml(name)}</strong>. Your message has been delivered. Reference: <code style="color: var(--cyan-primary); font-family: var(--font-mono);">${result.ticketId || 'JAL-REQ'}</code>
                </div>
              </div>
            </div>
          `;
          responseBox.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        }

        showToast('Message sent successfully!');
        contactForm.reset();
      } else {
        throw new Error(result.error || 'Failed to deliver message.');
      }
    } catch (err) {
      console.error('Contact Form Error:', err);
      if (responseBox) {
        responseBox.style.display = 'block';
        responseBox.innerHTML = `
          <div style="background: rgba(239, 68, 68, 0.15); border: 1px solid rgba(239, 68, 68, 0.4); border-radius: var(--radius-md); padding: 1.2rem 1.5rem; color: #FFFFFF; display: flex; align-items: center; gap: 0.8rem;">
            <span style="font-size: 1.4rem; color: #F87171;">✕</span>
            <div>
              <strong style="color: #F87171; font-size: 1rem;">Unable to Send Message</strong>
              <div style="font-size: 0.88rem; color: var(--text-secondary); margin-top: 0.2rem;">
                ${escapeHtml(err.message || 'Please check your connection and try again.')}
              </div>
            </div>
          </div>
        `;
      }
      showToast('Error sending message. Please try again.');
    } finally {
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.innerHTML = `
          <span>SEND MESSAGE</span>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="22" y1="2" x2="11" y2="13"/><polygon points="22 2 15 22 11 13 2 9 22 2"/></svg>
        `;
      }
    }
  });
}

function escapeHtml(str) {
  if (!str) return '';
  return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
